export const SHOPPING_CART_KEY_CREATE_FLOW = 'Phase1|ShoppingCartForAdPosting';
export const SHOPPING_CART_SUBSCRIPTION_RESPONSE_KEY = 'adProductsForAdPosting';
export const SHOPPING_CART_CAJA_PRODUCT_SET_KEY = 'cajaProductSet';
export const PROMO_CODE_BANNER_KEY = 'PromoCodeBanner';
